import * as React from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** エラー状態（aria-invalid に反映） */
  error?: boolean;
  /** エラーメッセージ要素のID（aria-describedby に反映） */
  errorMessageId?: string;
  /** ヘルプテキスト要素のID（aria-describedby に反映） */
  helpTextId?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, errorMessageId, helpTextId, ...props }, ref) => {
    // aria-describedby に設定するIDを構築
    const describedByIds = [errorMessageId, helpTextId].filter(Boolean).join(" ") || undefined;

    return (
      <input
        type={type}
        className={cn(
          "flex w-full rounded-md border border-input bg-background px-3 py-1 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground/70 dark:placeholder:text-muted-foreground/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          error && "border-destructive focus-visible:ring-destructive",
          className,
        )}
        ref={ref}
        aria-invalid={error || undefined}
        aria-describedby={describedByIds}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
